<template>
  <div class="theme-selector-list">
    <swiper ref="themeSwiper" :options="swiperOptions" :breakpoints="swiperOptions.breakpoints">
      <swiper-slide
        v-for="theme in themeChoices"
        :key="`theme-selector-slide-${theme.id}`"
        :qaid="`theme-selector-list__item-${theme.id}`"
      >
        <div class="flex flex-col items-center">
          <button
            :qaid="`theme-selector-list__button-${theme.id}`"
            class="theme-selector-list__button cursor-pointer text-center flex flex-col items-center"
            @click="selectTheme(theme.id)"
          >
            <img
              draggable="false"
              :qaid="`theme-selector-list__img__image-${theme.id}`"
              :src="buildImageUrl(theme)"
              :class="selectedThemeId === theme.id ? 'border-blue' : ''"
              class="theme-selector-list__img w-24 h-24 border-gray-10 border"
              alt="bear"
            />

            <h3
              :qaid="`theme-selector-list__description-${theme.id}`"
              class="font-medium text-sm leading-tight mt-1 mb-25"
              v-html="theme.marketingThemeGroup"
            />

            <span
              v-if="isHidingPrices"
              :qaid="`theme-selector-list__price-${theme.id}`"
              class="text-sm text-gray-60"
              v-html="bp('priceVaries')"
            />
            <span
              v-else-if="b2b && !consumerFriendlyMode"
              :qaid="`theme-selector-list__price-${theme.id}`"
              class="text-sm text-gray-60"
              v-html="theme.priceDifferenceDealerCost"
            />
            <span
              v-else
              :qaid="`theme-selector-list__price-${theme.id}`"
              class="text-sm text-gray-60"
              v-html="theme.priceDifferenceAdvertised"
            />
          </button>
        </div>
      </swiper-slide>
    </swiper>
    <trek-button tertiary icon-only icon="chevron_left" class="swiper-button-prev-custom" />
    <trek-button tertiary icon-only icon="chevron_right" class="swiper-button-next-custom" />
  </div>
</template>

<script>
import {swiper, swiperSlide} from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
import TrekButton from '@/components/TrekButton';
import {mapState} from 'vuex';

export default {
  name: 'ProjectOneThemeSelectorList',

  components: {swiper, swiperSlide, TrekButton},

  props: {
    themeChoices: {
      type: Array,
      required: true,
    },
    initialSelectedThemeId: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      selectedThemeId: this.initialSelectedThemeId,
      swiperOptions: {
        // default swiper slide settings
        slidesPerView: 'auto',
        spaceBetween: 24,
        centerInsufficientSlides: true,
        breakpoints: {
          // when window width is <= 639px
          639: {
            spaceBetween: 16,
          },
        },
        navigation: {
          nextEl: '.swiper-button-next-custom',
          prevEl: '.swiper-button-prev-custom',
        },
      },
    };
  },

  computed: {
    swiper() {
      return this.$refs.themeSwiper.swiper;
    },

    ...mapState('backend', ['b2b', 'consumerFriendlyMode']),
    ...mapState('projectOne', ['baseImageUrl', 'isHidingPrices']),
  },

  methods: {
    buildImageUrl(theme) {
      if (theme?.imageThumbnailReference) {
        return `${this.baseImageUrl + theme.imageThumbnailReference}`;
      }
    },

    selectTheme(id) {
      this.selectedThemeId = id;
      this.$emit('selected-theme', id);
    },
  },
};
</script>

<style lang="scss" scoped>
.theme-selector-list {
  position: relative;

  .swiper-container {
    max-width: 100%;
    max-height: 100vh;
    min-height: 0;
    min-width: 0;
    width: 80%;

    @screen lg {
      width: 90%;
    }
  }

  .swiper-slide {
    width: 6rem;
  }

  .swiper-button-prev-custom,
  .swiper-button-next-custom {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    overflow: hidden;
    width: 2rem;
    padding: 0;

    /deep/ > i {
      font-size: 3rem;
    }
  }

  .swiper-button-prev-custom {
    left: 0;
  }

  .swiper-button-next-custom {
    right: 0;
  }

  .swiper-button-disabled {
    cursor: auto;
    pointer-events: none;
    opacity: 0;
  }

  &__button {
    &:hover {
      .theme-selector-list__img {
        @apply shadow-md;
      }
    }
  }

  &__img {
    transition: all 0.4s cubic-bezier(0, 0, 0.2, 1);
  }
}
</style>
